import { Box, Checkbox, Text, Image } from "@chakra-ui/react";
import { useRecoilState } from "recoil";
import { currentTemplateAtom } from "../../../atoms/templates";
import { createCampaignAtom } from "../../../atoms/campaigns";
import { removeHTMLTags } from "../../../functions";

export function TemplateEmailVisualCard({
  title,
  content,
  uid,
  design,
}: {
  title: string;
  content: string;
  uid: string;
  design: any;
}) {
  const [currTemplate, setCurrTemplate] = useRecoilState(currentTemplateAtom);
  const [currentStageData, setCurrentStageData] =
    useRecoilState(createCampaignAtom);

  if (currentStageData) {
    // console.log(currentStageData)
  }

  const setCurr = () => {
    setCurrTemplate((prev) => ({
      ...prev,
      uid: uid,
    }));
  };

  return (
    <Box
      onClick={() => {
        setCurr();
        setCurrentStageData((prevValue) => {
          return {
            ...prevValue,
            data: {
              ...prevValue?.data,
              template_uid: uid,
              message_body: design,
            },
          };
        });
      }}
    >
      <Box
        height={259.92}
        w={241.63}
        border={currTemplate.uid === uid ? '1px solid #0066FF': '1px solid #D6E7FF'}
        mr={5}
        role="button"
      >
        <Box h={"80%"} bg={"#E6E6E680"}>
          <Box display={"flex"} justifyContent={"end"} p={2}>
            <Checkbox isChecked={currTemplate.uid === uid} bg={"white"} />
          </Box>
          {uid === "blank" ? (
            <Box mt={10}>
              <Image src="/blank.png" margin={"auto"} />
            </Box>
          ) : (
            <Box
              mt={10}
              p={2}
              w={150}
              m={"auto"}
              h={"70%"}
              fontSize={"10px"}
              bg={"white"}
            >
              <Text noOfLines={2}> {removeHTMLTags(content || "content")}</Text>
            </Box>
          )}
        </Box>
        <Text fontWeight={500} fontSize={12} textAlign={"center"} mt={3}>
          {title}
        </Text>
      </Box>

      {/* <Box
        px="0.8em"
        overflowY={"hidden"}
        borderTop={`1px solid rgba(26, 171, 252, 0.16)`}
        display="grid"
        // alignSelf='end'
        bg="white"
        borderRadius="0px 0px 4px 4px"
        color="#171D26"
        fontSize="11px"
        fontWeight="700"
        py={"8px"}
      >
        <Text noOfLines={2}> {removeHTMLTags(content || "content")}</Text>
       
      </Box> */}
    </Box>
  );
}
